{
  "Audio Player": "Audio Player",
  "Video Player": "Video Player",
  "Play": "Play",
  "Pause": "Pause",
  "Replay": "Replay",
  "Current Time": "Current Time",
  "Duration": "Duration",
  "Remaining Time": "Remaining Time",
  "Stream Type": "Stream Type",
  "LIVE": "LIVE",
  "Loaded": "Loaded",
  "Progress": "Progress",
  "Progress Bar": "Progress Bar",
  "progress bar timing: currentTime={1} duration={2}": "{1} of {2}",
  "Fullscreen": "Fullscreen",
  "Non-Fullscreen": "Non-Fullscreen",
  "Mute": "Mute",
  "Unmute": "Unmute",
  "Playback Rate": "Playback Rate",
  "Subtitles": "Subtitles",
  "subtitles off": "subtitles off",
  "Captions": "Captions",
  "captions off": "captions off",
  "Chapters": "Chapters",
  "Descriptions": "Descriptions",
  "descriptions off": "descriptions off",
  "Audio Track": "Audio Track",
  "Volume Level": "Volume Level",
  "You aborted the media playback": "You aborted the media playback",
  "A network error caused the media download to fail part-way.": "A network error caused the media download to fail part-way.",
  "The media could not be loaded, either because the server or network failed or because the format is not supported.": "The media could not be loaded, either because the server or network failed or because the format is not supported.",
  "The media playback was aborted due to a corruption problem or because the media used features your browser did not support.": "The media playback was aborted due to a corruption problem or because the media used features your browser did not support.",
  "No compatible source was found for this media.": "No compatible source was found for this media.",
  "The media is encrypted and we do not have the keys to decrypt it.": "The media is encrypted and we do not have the keys to decrypt it.",
  "Play Video": "Play Video",
  "Close": "Close",
  "Close Modal Dialog": "Close Modal Dialog",
  "Modal Window": "Modal Window",
  "This is a modal window": "This is a modal window",
  "This modal can be closed by pressing the Escape key or activating the close button.": "This modal can be closed by pressing the Escape key or activating the close button.",
  ", opens captions settings dialog": ", opens captions settings dialog",
  ", opens subtitles settings dialog": ", opens subtitles settings dialog",
  ", opens descriptions settings dialog": ", opens descriptions settings dialog",
  ", selected": ", selected",
  "captions settings": "captions settings",
  "subtitles settings": "subtitles settings",
  "descriptions settings": "descriptions settings",
  "Text": "Text",
  "White": "White",
  "Black": "Black",
  "Red": "Red",
  "Green": "Green",
  "Blue": "Blue",
  "Yellow": "Yellow",
  "Magenta": "Magenta",
  "Cyan": "Cyan",
  "Background": "Background",
  "Window": "Window",
  "Transparent": "Transparent",
  "Semi-Transparent": "Semi-Transparent",
  "Opaque": "Opaque",
  "Font Size": "Font Size",
  "Text Edge Style": "Text Edge Style",
  "None": "None",
  "Raised": "Raised",
  "Depressed": "Depressed",
  "Uniform": "Uniform",
  "Dropshadow": "Dropshadow",
  "Font Family": "Font Family",
  "Proportional Sans-Serif": "Proportional Sans-Serif",
  "Monospace Sans-Serif": "Monospace Sans-Serif",
  "Proportional Serif": "Proportional Serif",
  "Monospace Serif": "Monospace Serif",
  "Casual": "Casual",
  "Script": "Script",
  "Small Caps": "Small Caps",
  "Reset": "Reset",
  "restore all settings to the default values": "restore all settings to the default values",
  "Done": "Done",
  "Caption Settings Dialog": "Caption Settings Dialog",
  "Beginning of dialog window. Escape will cancel and close the window.": "Beginning of dialog window. Escape will cancel and close the window.",
  "End of dialog window.": "End of dialog window.",
  "ISO-639-1": "en",
  "10 seconds backward": "10 seconds backward",
  "30 seconds forward": "30 seconds forward",
  "Audio": "Audio",
  "Audio and subtitles": "Audio and subtitles",
  "Audio Description": "Audio Description",
  "Auto play": "Auto play",
  "Back": "Back",
  "Casting to": "Casting to",
  "Content will be available in {1} days": "Content will be available in {1} days",
  "Current position": "Current position",
  "Current subject": "Current subject",
  "Days": "Days",
  "Duration: {1}": "Duration: {1}",
  "Edit player settings": "Edit player settings",
  "Episode": "Episode",
  "HD": "HD",
  "Continuous Playback": "Continuous Playback",
  "Cancel": "Cancel",
  "Coming next": "Coming next",
  "Copied": "Copied",
  "copy": "copy",
  "Copy debug info": "Copy debug info",
  "Copy link": "Copy link",
  "Facebook": "Facebook",
  "Font size level {1}": "Font size level {1}",
  "Hours": "Hours",
  "Integrate": "Integrate",
  "Issue:": "Issue:",
  "LinkedIn": "LinkedIn",
  "Mail": "Mail",
  "Minutes": "Minutes",
  "Off": "Off",
  "Open {1} in Play {2}": "Open {1} in Play {2}",
  "Playback will begin shortly": "Playback will begin shortly",
  "Please indicate the problem below, so that we can help you:": "Please indicate the problem below, so that we can help you:",
  "Quality": "Quality",
  "Report a technical problem": "Report a technical problem",
  "SD": "SD",
  "Seconds": "Seconds",
  "Seek to live, currently behind live": "Seek to live, currently behind live",
  "Seek to live, currently playing live": "Seek to live, currently playing live",
  "Send bug report": "Send bug report",
  "Share at current position": "Share at current position",
  "Share by e-mail": "Share by e-mail",
  "Share": "Share",
  "Share on {1}": "Share on {1}",
  "Share on Facebook": "Share on Facebook",
  "Share on Linkedin": "Share on Linkedin",
  "Share on Twitter": "Share on Twitter",
  "Share on Whatsapp": "Share on Whatsapp",
  "Share on X": "Share on X",
  "Share the current subject": "Share the current subject",
  "Share the episode": "Share the episode",
  "Skip credits": "Skip credits",
  "Skip intro": "Skip intro",
  "Speed": "Speed",
  "Start casting": "Start casting",
  "Start pip": "Start picture in picture",
  "Stop": "Stop",
  "Stop casting": "Stop casting",
  "Stop pip": "Stop picture in picture",
  "The content cannot be played.": "The content cannot be played.",
  "This content cannot be played while using a VPN.": "This content cannot be played while using a VPN.",
  "The content was skipped due to legal restriction": "The content was skipped due to legal restriction",
  "This content is temporarily unavailable for journalistic reasons.": "This content is temporarily unavailable for journalistic reasons.",
  "This commercial media is not available.": "This commercial media is not available.",
  "This content is not available.": "This content is not available.",
  "This content is not available anymore.": "This content is not available anymore.",
  "This content is not available due to legal restrictions.": "This content is not available due to legal restrictions.",
  "This content is not available outside Switzerland.": "This content is not available outside Switzerland.",
  "This content is not yet available. Please try again later.": "This content is not yet available. Please try again later.",
  "To protect children, this content is only available between 8PM and 6AM.": "To protect children, this content is only available between 8PM and 6AM.",
  "To protect children, this content is only available between 11PM and 5AM.": "To protect children, this content is only available between 11PM and 5AM.",
  "Twitter": "Twitter",
  "Unable to display the content. For more information and help, click here...": "Unable to display the content. For more information and help, click here...",
  "Unfortunately the 360 playback experience is not compatible with your browser version.": "Unfortunately the 360 playback experience is not compatible with your browser version.",
  "Unfortunately this format is not compatible with your browser.": "Unfortunately this format is not compatible with your browser.",
  "WhatsApp": "WhatsApp",
  "X": "X"
}
